import React from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import ContactSection from '../sections/ContactSection/ContactSection';
import Layout from '../layouts/Layout';

const RequestPage = ({ location }) => {
    const data = useStaticQuery(query);
    const form = 'https://fs3yzb3nh3.execute-api.us-east-1.amazonaws.com/'
        + 'prod-aws/flotiq-forms/request_a_demo-ehxCmh5vw';
    return (
        <>
            <Helmet>
                <title>
                    Request a demo
                </title>
                <script
                    src={form}
                    async
                />
                <meta
                    name="description"
                    content="Request a demo and see the whole potential of Flotiq headless CMS
                    for individuals and enterprises."
                />
                <meta
                    property="og:site_name"
                    content={data.allMainPageSettings.nodes[0].seo_title}
                />
                <meta
                    property="og:title"
                    content="Request a demo"
                />
                <meta
                    property="og:image"
                    content={data.allMainPageSettings.nodes[0].seo_image?.[0]?.localFile.publicURL}
                />
                <meta
                    name="twitter:title"
                    content="Request a demo"
                />
                <link rel="canonical" href={`${location.origin}/request-a-demo/`} />
            </Helmet>
            <Layout>
                <ContactSection data={data.allContactPageSettings.nodes[0]} />
            </Layout>
        </>
    );
};

const query = graphql`
    query RequestPageQuery {
        allFlotiqMainSettings {
            nodes {
                title
            }
        }
        allMainPageSettings {
            nodes {
                seo_title
                seo_image {
                    localFile {
                        publicURL
                    }
                }
                seo_description
            }
        }
        allContactPageSettings {
            nodes {
                title
                contact_form_header
                contact_form_description
                contact_help_section_image_desktop {
                    localFile {
                        publicURL
                    }
                }
                contact_help_section_image_mobile {
                    localFile {
                        publicURL
                    }
                }
                contact_help_section_image_alt
                contact_help_section_list {
                    list_item
                }
            }
        }
    }
`;

export default RequestPage;
